import React from 'react'
import $t from '../../../i18n'
import config from '../../../config.json'
import './EmptyList.css'

const EmptyList = ({ title }) => {
  return (
    <div className="empty-list-container">
      <img
        src={config.gcpStorageUrl + '/img/empty_list.png'}
        className="empty-img"
        alt=""
      />
      <div className="title"> {title || $t('alerts.noItems')} </div>
    </div>
  )
}

export default EmptyList
